<!-- 智慧助手辅助生成按钮 -->
<script setup>
import { eventBus } from "@/main";
import EventCenter from "@/utils/EventCenter";

// eslint-disable-next-line no-undef
const props = defineProps({
  command: {
    type: String,
    required: true,
  },
});

function openAiComp() {
  eventBus.$emit(EventCenter.PropsParamSuggestByAIReplyComp, props.command);
}
</script>

<template>
  <el-button class="global-ai-help-button" type="text" @click="openAiComp">{{ $t('bot-store.AI-Help-Generate') }}</el-button>
</template>
<style lang="scss" scoped>
.global-ai-help-button {
  padding: 12px 4px;
}
</style>
